/*
 * File: types.ts
 * Project: sso-frontend
 * File Created: Tuesday, 24th May 2022 5:58:01 pm
 * Author: Steven Chiffe (steven.chiffe@alyce.fr)
 * -----
 * Last Modified: Thursday, 1st September 2022 11:22:32 am
 * Modified By: Steven Chiffe (steven.chiffe@alyce.fr>)
 * -----
 * Copyright Py-Factory - 2022
 */

export enum FormType {
  "CREATE" = "CREATE",
  "UPDATE" = "UPDATE",
  "DELETE" = "DELETE",
  "SEND_MAIL" = "SEND_MAIL",
  "UPDATE_MULTIPLE" = "UPDATE_MULTIPLE",
  "NOTHING" = "NOTHING"
}

export enum UserRolePower {
  "ADMINISTRATOR" = 0,
  "SUPERVISEUR" = 1,
  "POSEUR" = 2
}

export enum UserRole {
  "ADMINISTRATOR" = "ADMIN",
  "SUPERVISEUR" = "SUPERVISEUR",
  "POSEUR" = "POSEUR"
}

export interface UserDataTable {
  _id: string;
  mail: string;
  agence: string;
  role: string;
}

export interface DeviceDataTable {
  _id: string;
  material_name: string;
  agence: string;
  disponibility: boolean;
  category: string;
  state: string;
  updated: string;
  campaign: string;
  poste: string;
}

export interface DeviceDescriptionDataTable {
  _id: string;
  name_poste: string;
  typology: string;
  survey_name: string | undefined;
  survey_id_budget: string | undefined;
}

export interface SurveyDescriptionDataTable {
  _id: string;
  name_poste: string;
  typology: string;
  material_name: string;
}

export interface SurveyDataTable {
  _id: string;
  id_budget: string;
  name_survey: string;
  agence: string;
  type: string;
  user: string;
  active: boolean | string;
  start_date: string;
  end_date: string;
}

export enum ApiResponse {
  "SUCCESS" = 200,
  "CREATED" = 201,
  "SERVER_ERROR" = 500
}

export interface UserFilters {
  mail: string;
  agence: string;
  role: string;
}

export type DeviceFilterName =
  | "disponibility"
  | "material_name"
  | "category"
  | "state"
  | "agence"
  | "updated"
  | "campaign";
export type DeviceFilters = { [filter in DeviceFilterName]: string };

export type SurveyFilterName = "active" | "id_budget" | "survey_name" | "type" | "agence";
export type SurveyFilters = { [filter in SurveyFilterName]: string };

export interface Location_ {
  longitude?: number;
  latitude?: number;
}

export interface ArrowLocation {
  left?: Location_;
  right?: Location_;
  top?: Location_;
  bottom?: Location_;
}
export interface IMapDataDefinition {
  name: string;
  comment: string;
  type?: string;
  location?: Location_;
  theoretical_location?: Location_;
  polygon_location?: Array<Location_>;
  angle_location?: Array<Location_>;
  arrows_location?: ArrowLocation;
}

export enum PosteType {
  "CA" = "CA",
  "CD" = "CD",
  "CS" = "CS"
}

export type OsPlatform = "windows" | "mac" | "linux";

export type PickStr<T> = {
  [P in keyof T as string]: T[P];
};

export enum MainStateEnum {
  "RESERVE" = "Réserve",
  "TERRAIN" = "Terrain",
  "ATELIER" = "Atelier",
  "AUTRE" = "Autre"
}

export enum StateEnum {
  "RESERVE_DISP" = "Réserve - Disponible"
}

export enum typeOfDisplay {
  TABLE = "table",
  GRAPH = "graph",
  CARD = "card"
}
